import { toast } from "react-toastify";
import { defaultToastOptions } from "./misc";

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";

  try {
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    toast.success("Landing Page link copied to clipboard", defaultToastOptions);
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    toast.error(
      "Error copying to clipboard, Please try again",
      defaultToastOptions,
    );
  } finally {
    document.body.removeChild(textArea);
  }
};

export const copyTextToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function pass() {
      toast.success(
        "Landing Page link copied to clipboard",
        defaultToastOptions,
      );
    },
    function fail(err) {
      console.warn(err);
      toast.success("Async: Could not copy text:", defaultToastOptions);
    },
  );
};
